<template>
  <vx-card no-shadow>
    <p v-if="isSuccess || isError">{{message}}</p><br/>
    <div v-for="placeholder in placeholders" :key="placeholder.key">
       <!-- The Future Is Now -->
      <div class="mt-8" v-if="(placeholder.key === 'section3') || (placeholder.key === 'section4') || (placeholder.key === 'section5')">
        {{placeholder.key}}
          <div v-show="!isEditing" :disabled="!isEditing">
            <vs-input class="w-full mt-8" type="text" label-placeholder="Header" v-model="placeholder.header" :disabled="!isEditing"/>
            <vs-input class="w-full mt-8 mb-8" type="text" label-placeholder="Sub Header" v-model="placeholder.subHeader"  :disabled="!isEditing"/>
            <vs-textarea label="text" v-model="placeholder.description" :disabled="!isEditing"/>
          </div>
          <div v-show="isEditing">
            <vs-input class="w-full mt-8" type="text" label-placeholder="Header" v-model="pcdata.header"/>
            <vs-input class="w-full mt-8 mb-8" type="text" label-placeholder="Sub Header" v-model="pcdata.subHeader" />
            <vs-textarea label="text" v-model="pcdata.description"/>
          </div>
          <div class="flex flex-wrap items-center justify-end">
          <vs-button class="ml-auto mt-2"  @click="editData(placeholder)"> Edit</vs-button>
        </div>
      </div>

     <vs-popup class="w:full" title="Edit section" :active.sync="isEditing">
       <vs-input class="w-full mt-8" type="text" label-placeholder="Header" v-model="pcdata.header"/>
        <vs-input class="w-full mt-8 mb-8" type="text" label-placeholder="Sub Header" v-model="pcdata.subHeader" />
        <vs-textarea label="text" height="200px" v-model="pcdata.description"/>
        <vs-button class="ml-4 mt-2"  @click="updateData">save</vs-button>
     </vs-popup>
      
      <!-- DeMystifying Robots -->
      <!-- <div class="mt-8" v-if="placeholder.key === 'section4'">
        {{placeholder.key}}
          <div v-show="!isEditing" :disabled="!isEditing">
            <vs-input class="w-full mt-8" type="text" label-placeholder="Header" v-model="placeholder.header" :disabled="!isEditing"/>
            <vs-input class="w-full mt-8 mb-8" type="text" label-placeholder="Sub Header" v-model="placeholder.subHeader"  :disabled="!isEditing"/>
            <vs-textarea label="text" v-model="placeholder.description" :disabled="!isEditing"/>
          </div>
          <div v-show="isEditing">
            <vs-input class="w-full mt-8" type="text" label-placeholder="Header" v-model="pcdata.header"/>
            <vs-input class="w-full mt-8 mb-8" type="text" label-placeholder="Sub Header" v-model="pcdata.subHeader" />
            <vs-textarea label="text" v-model="pcdata.description"/>
          </div>
          <div class="flex flex-wrap items-center justify-end">
          <vs-button class="ml-auto mt-2" @click="editData(placeholder)"> Edit</vs-button>
          <vs-button class="ml-4 mt-2" @click="updateData">save</vs-button>
        </div>
      </div> -->

      <!-- For kits books videos -->
      <!-- <div class="mt-8" v-if="placeholder.key === 'section5'">
        {{placeholder.key}}
          <div v-show="!isEditing" :disabled="!isEditing">
            <vs-input class="w-full mt-8" type="text" label-placeholder="Header" v-model="placeholder.header" :disabled="!isEditing"/>
            <vs-input class="w-full mt-8 mb-8" type="text" label-placeholder="Sub Header" v-model="placeholder.subHeader"  :disabled="!isEditing"/>
            <vs-textarea label="text" v-model="placeholder.description" :disabled="!isEditing"/>
          </div>
          <div v-show="isEditing">
            <vs-input class="w-full mt-8" type="text" label-placeholder="Header" v-model="pcdata.header"/>
            <vs-input class="w-full mt-8 mb-8" type="text" label-placeholder="Sub Header" v-model="pcdata.subHeader" />
            <vs-textarea label="text" v-model="pcdata.description"/>
          </div>
          <div class="flex flex-wrap items-center justify-end">
          <vs-button class="ml-auto mt-2" @click="editData(placeholder)"> Edit</vs-button>
          <vs-button class="ml-4 mt-2" @click="updateData">save</vs-button>
        </div>
      </div> -->
    </div>

    <!-- add new section -->
    <div class="mt-8">
        <vs-select v-model="dataKey" class="w-full select-large" label="Parent Category">
          <vs-select-item :key="index" :value="item.value" :text="item.text" v-for="(item,index) in sectionChoices" class="w-full" />
        </vs-select>
        <!-- <vs-input class="w-full" label="Section Name" name="item-name" v-model="dataKey"/> -->
        <vs-input class="w-full mt-8" type="text" label="Header" v-model="dataHeader"/>
        <vs-input class="w-full mt-8 mb-8" type="text" label="Sub Header" v-model="dataSubHeader"/>
        <vs-textarea label="text" v-model="dataDescription"/>
        <div class="flex flex-wrap items-center justify-end">
          <vs-button class="ml-auto mt-2" @click="submitSection"> add new section</vs-button>
          <!-- <vs-button class="ml-4 mt-2" @click="updateData">save</vs-button> -->
        </div>
    </div> 

    <!-- Section-9 -->
    <!-- <div class="mt-8">
        <label class="text-sm ">Coming Soon</label>
        <vs-textarea label="text" />
    </div>   -->

    <!-- Save & Reset Button -->
    <!-- <div class="flex flex-wrap items-center justify-end">
      <vs-button class="ml-auto mt-2">Save Changes</vs-button>
      <vs-button class="ml-4 mt-2" type="border" color="warning">Reset</vs-button>
    </div> -->
  </vx-card>
</template>

<script>
import flatPickr from 'vue-flatpickr-component'
import 'flatpickr/dist/flatpickr.css'
import vSelect from 'vue-select'
import moduleHomepageManagement from '@/store/homepage/moduleHomepageManagement.js'


export default {
  components: {
    flatPickr,
    vSelect
  },
  data () {
    return {
      bio: this.$store.state.AppActiveUser.about,
      dob: null,
      isEditing: false,
      pcdata: {},
      dataKey: null,
      dataHeader: null,
      dataSubHeader: null,
      dataDescription: null,
      isSuccess: false,
      isError : false,
      message : '',
      sectionChoices: [
        {text:'section3', value:'section3'},
        {text:'section4', value:'section4'},
        {text:'section5', value:'section5'}
      ],
      isSection: true
    }
  },
  computed: {
    activeUserInfo () {
      return this.$store.state.AppActiveUser
    },
    placeholders () {
      return this.$store.state.placeholders.placeholders
    }
  },
  methods: {
    initValues () {
      this.dataKey = null
      this.dataHeader = null
      this.dataSubHeader = null
      this.dataDescription = null

    },
    updateData () {
      const obj = {
        key: this.pcdata.key,
        header: this.pcdata.header,
        subHeader: this.pcdata.subHeader,
        description: this.pcdata.description
      }
      console.log('updated section data', obj)
      if (this.pcdata.key !== null) {
        this.$store.dispatch('placeholders/updatePlaceholder', obj)
          .then(
            // this.$showSuccessToast(this, `${obj.key} updated`)
            this.successMsg(`${obj.key} updated`)
          )
          .catch(err => { 
            this.errorMsg(err)
            console.error(err) 
          })
      }
      this.isEditing = false
    },
    editData (placeholder) {
      this.isEditing = true
      this.pcdata = placeholder
    },
    successMsg (msg) {
      this.isSuccess = true
      this.message = msg
    },
    errorMsg (msg) {
      this.isError = true
      this.message = msg
    },
    submitSection () {
      const newObj = {
        key: this.dataKey,
        header: this.dataHeader,
        subHeader: this.dataSubHeader,
        description: this.dataDescription
      }
      // console.log('new section data', newObj)
      if (newObj.key !== null) {
        this.$store.dispatch('placeholders/addPlaceholder', newObj)
          .then(this.successMsg(`${newObj.key} is added`))
          .catch(err => { 
            this.errorMsg(err)
            console.error(err) 
          })
      } else {
        this.errorMsg('Fill out section name')
      }
      this.initValues()
    }
  },
  created () {
    if (!moduleHomepageManagement.isRegistered) {
      this.$store.registerModule('placeholders', moduleHomepageManagement)
      moduleHomepageManagement.isRegistered = true
    }
    this.$store.dispatch('placeholders/fetchPlaceholders')
  }
}
</script>
